import * as types from './qualificationAward.types'

export const actions = {
	toggleLoading: payload => ({
		type: types.TOGGLE_LOADING,
		payload,
	}),
	toggleSuccess: payload => ({
		type: types.TOGGLE_SUCCESS,
		payload,
	}),
	set: payload => ({
		type: types.SET_QUALIFICATION_AWARD,
		payload,
	}),
	create: payload => ({
		type: types.CREATE_QUALIFICATION_AWARD,
		payload,
	}),
	get: payload => ({
		type: types.GET_QUALIFICATION_AWARD,
		payload,
	}),
	edit: payload => ({
		type: types.EDIT_QUALIFICATION_AWARD,
		payload,
	}),
	delete: payload => ({
		type: types.DELETE_QUALIFICATION_AWARD,
		payload,
	}),
	getOptions: () => ({
		type: types.GET_OPTIONS,
	}),
	setOptions: payload => ({
		type: types.SET_OPTIONS,
		payload,
	}),
	setErrors: payload => ({
		type: types.SET_ERRORS,
		payload,
	}),
	clearData: payload => ({
		type: types.CLEAR_DATA,
		payload,
	}),
	setPermissions: payload => ({
		type: types.SET_PERMISSIONS,
		payload,
	}),
}
